import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// The TaskFlow logo glyph: a check inside a rounded square (a ticked checkbox).
// public/logo.svg draws the same paths on the indigo tile, so the browser-tab
// icon matches the in-app mark. Change both together.
export default function BrandMark(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
        <rect x={3.5} y={3.5} width={17} height={17} rx={5} />
        <path d="M8 12.4l2.8 2.8 5.2-5.6" />
      </g>
    </SvgIcon>
  );
}
